import { useMediaQuery, useTheme } from '@mui/system'

export function useIsMobile(breakpoint: 'md' | 'sm') {
  const { breakpoints } = useTheme()
  const isMobile = useMediaQuery(breakpoints.down(breakpoint))

  return isMobile
}
